module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c",
    attrs: {
      "id": "contents"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "tocpart"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#part1"
    }
  }, [_vm._v("PART I")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch1#ch1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER ONE:")]), _vm._v(" "), _c('em', [_vm._v("From Coney Island to William Morris to Hollywood")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2#ch2"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER TWO:")]), _vm._v(" "), _c('em', [_vm._v("Actually making movies")]), _vm._v(", Double Trouble, "), _c('em', [_vm._v("and a very tough Lee Marvin in")]), _vm._v(" Point Blank")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER THREE:")]), _vm._v(" "), _c('em', [_vm._v("A rebuff of Shakespeare, a welcome from Jack Warner, and diversity")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER FOUR:")]), _vm._v(" "), _c('em', [_vm._v("From the college campus uprising, to decadence in London, to a Hollywood dance marathon, to the Cannes Film Festival")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpartt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#part2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART II")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER FIVE:")]), _vm._v(" "), _c('em', [_vm._v("Starting a long friendship with the great actor Bob De Niro, the 1970s drug culture, and two different looks at the Los Angeles Police Department")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER SIX:")]), _vm._v(" "), _c('em', [_vm._v("From Africa with Barbra Streisand to Charlie Bronson and a fine script that went sour")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER SEVEN:")]), _vm._v(" "), _c('em', [_vm._v("To quote Rick in")]), _vm._v(" Casablanca, "), _c('em', [_vm._v("“This is the beginning of a beautiful friendship.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER EIGHT:")]), _vm._v(" "), _c('em', [_vm._v("From")]), _vm._v(" Rocky "), _c('em', [_vm._v("to Oscar")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpartt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#part3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART III")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER NINE:")]), _vm._v(" "), _c('em', [_vm._v("A very different fight film")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER TEN:")]), _vm._v(" "), _c('em', [_vm._v("De Niro and Pacino have")]), _vm._v(" The Right Stuff")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpartt"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part4#part4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART IV")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER ELEVEN:")]), _vm._v(" "), _c('em', [_vm._v("The Cold War stars in one movie, the Revolutionary War in another, and one very fine movie doesn’t get made")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER TWELVE:")]), _vm._v(" "), _c('em', [_vm._v("A trip to Paris pays off")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER THIRTEEN:")]), _vm._v(" "), _c('em', [_vm._v("Two political films and a couple of")]), _vm._v(" Goodfellas")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER FOURTEEN:")]), _vm._v(" "), _c('em', [_vm._v("A career change from producer to director, back to producer (almost)")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER FIFTEEN:")]), _vm._v(" "), _c('em', [_vm._v("Working with some special ladies—Sandra Bullock and Demi Moore—and a special doctor, Oliver Sacks")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER SIXTEEN:")]), _vm._v(" "), _c('em', [_vm._v("Life with Kevin Kline is")]), _vm._v(" De-Lovely; "), _c('em', [_vm._v("a director gets bullied into not making a film")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER SEVENTEEN:")]), _vm._v(" "), _c('em', [_vm._v("From Camp Polk, Louisiana, to the Iraq War")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpartt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5#part5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART V")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER EIGHTEEN:")]), _vm._v(" "), _c('em', [_vm._v("A wild ride to Wall Street, a gamble turning over a classic to a new generation, a sad loss, and a long-delayed")]), _vm._v(" Silence")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpartt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6#part6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PART VI")])]), _vm._v(" "), _c('p', {
    staticClass: "tocchapb"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CHAPTER NINETEEN:")]), _vm._v(" "), _c('em', [_vm._v("Old Friends")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epiloge#epiloge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo#photo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Credits")]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 69
// module chunks = 0